// @flow

import gql from 'graphql-tag';

export type ProfileObject = {
  id: string,
  first_name: string,
  last_name: string,
  email: string,
  email_hash: string,
  is_developer: string,
  is_staff: string,
};

export type ProfileResponse = {
  active_id: number,
  objects: ProfileObject[],
};

export default gql`
  fragment ProfileFragment on Profile {
    active_id
    objects {
      id
      first_name
      last_name
      email
      email_hash
      is_developer
      is_staff
    }
  }
`;
